import React from "react";
import styles from "./learn.module.css";
import { Button, Section, SectionIntro } from "../../../../COMPONENTS/UI";
import Reveal from "../../../../COMPONENTS/ANIMATION/Reveal";
import { participation, steps } from "../../../../CONTENT/patients";

export const Expect = () => (
  <Section tone="cloud" id="expect" labelledBy="expect-title">
    <SectionIntro
      id="expect-title"
      eyebrow="What to expect"
      title="How taking part works."
      lead="Every study is different, but most follow the same path."
    />
    <ol className={styles.steps}>
      {steps.map((s, i) => (
        <Reveal as="li" key={s.title} delay={i * 0.08} className={styles.step}>
          <span className={styles.num} aria-hidden="true">
            {String(i + 1).padStart(2, "0")}
          </span>
          <h3 className={styles.stepTitle}>{s.title}</h3>
          <p className={styles.stepText}>{s.text}</p>
        </Reveal>
      ))}
    </ol>

    <div className={styles.benefits}>
      <h3 className={styles.benefitsTitle}>What participation means for you</h3>
      <ul className={styles.benefitList}>
        {participation.map((p) => (
          <li key={p.title}>
            <strong>{p.title}</strong>
            <span>{p.text}</span>
          </li>
        ))}
      </ul>
      <Button href="/network/locations" variant="link" tone="light">
        Find a KUR location near you
      </Button>
    </div>
  </Section>
);
